import {
  APP_SETTING_ADD_PROJECT_CUSTOM_CSS_KLASS_BEGIN,
  APP_SETTING_ADD_PROJECT_CUSTOM_CSS_KLASS_SUCCESS,
  APP_SETTING_ADD_PROJECT_CUSTOM_CSS_KLASS_FAILURE,
  APP_SETTING_ADD_PROJECT_CUSTOM_CSS_KLASS_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function addProjectCustomCssClass(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_ADD_PROJECT_CUSTOM_CSS_KLASS_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/custom-css-class`,
        args.data,
        header,
      );

      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: APP_SETTING_ADD_PROJECT_CUSTOM_CSS_KLASS_SUCCESS,
              data: res.data,
            });
            toast.success('Custom Class Created Successfully!', {});
            resolve(res.data);
          } else {
            dispatch({
              type: APP_SETTING_ADD_PROJECT_CUSTOM_CSS_KLASS_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: APP_SETTING_ADD_PROJECT_CUSTOM_CSS_KLASS_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissAddProjectCustomCssClassError() {
  return {
    type: APP_SETTING_ADD_PROJECT_CUSTOM_CSS_KLASS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_ADD_PROJECT_CUSTOM_CSS_KLASS_BEGIN:
      return {
        ...state,
        addProjectCustomCssClassPending: true,
        addProjectCustomCssClassError: null,
      };

    case APP_SETTING_ADD_PROJECT_CUSTOM_CSS_KLASS_SUCCESS:
      return {
        ...state,
        addProjectCustomCssClassPending: false,
        addProjectCustomCssClassError: null,
        projectDetail: action.data,
      };

    case APP_SETTING_ADD_PROJECT_CUSTOM_CSS_KLASS_FAILURE:
      return {
        ...state,
        addProjectCustomCssClassPending: false,
        addProjectCustomCssClassError: action.data.error,
      };

    case APP_SETTING_ADD_PROJECT_CUSTOM_CSS_KLASS_DISMISS_ERROR:
      return {
        ...state,
        addProjectCustomCssClassError: null,
      };

    default:
      return state;
  }
}
